import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CustomUrlSchemeHandler {
  handleUrl(emailBody: string, attachments): string {
    if (emailBody.includes('src="cid:')) {
      let filenameList = emailBody.split('src="cid:');
      for (let i = 1; i < filenameList.length; i++) {
        let filename = filenameList[i].split('"')[0].split('@')[0];
        if (attachments && attachments.length > 0) {
          // Replace 'cid:' with the appropriate base64 data from attachemt that matches the cid value
          attachments.forEach((attachment) => {
            if (attachment.filename === filename) {
              emailBody = this.replaceCidWithBase64(emailBody, attachment.filename, attachment.data);
            }
          });
        }
      }
      if (emailBody.includes('<img')) {
        emailBody = emailBody.replace('<img', '<img style="max-width:100%; max-height:100%;"');
      }
      return emailBody;
    }
    return emailBody;
  }

  replaceCidWithBase64(emailBody: string, filename: string, data: any): string {
    const cidPattern = new RegExp(`src="cid:${filename}@[^"]*"`, 'g');
    const base64DataUrl = `src="data:${filename};base64,${data}"`;
    return emailBody.replace(cidPattern, base64DataUrl);
  }
}
